import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd402c96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "test" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head-wrap" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "お試し")
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "margin-bottom10" }, "黒枠に好きな文章を入力。カテゴリを押すとそのカテゴリの単語がランダムで入るように設定出来ます。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "search-tool" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "テンプレート", -1))
const _hoisted_10 = { class: "btns" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", {
        class: "theme-input",
        contenteditable: "true",
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args))),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateCaretPos())),
        ref: "textarea"
      }, _hoisted_6, 544),
      _createElementVNode("div", {
        class: "scroll",
        onMousewheelPassive: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseWheel && _ctx.mouseWheel(...args)))
      }, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.choice('自分の名前')))
          }, "自分の名前"),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
            return (_openBlock(), _createElementBlock("li", {
              onClick: ($event: any) => (_ctx.choice(cat.name)),
              key: cat.id
            }, _toDisplayString(cat.name), 9, _hoisted_8))
          }), 128))
        ])
      ], 32),
      _hoisted_9,
      _createElementVNode("ul", _hoisted_10, [
        _createElementVNode("li", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeText(0)))
        }, "面接"),
        _createElementVNode("li", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeText(1)))
        }, "ニュース1"),
        _createElementVNode("li", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeText(2)))
        }, "ニュース2")
      ]),
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
      }, "変換"),
      _createElementVNode("p", {
        class: "result",
        innerHTML: _ctx.state.resText,
        style: {"white-space":"pre-wrap"}
      }, null, 8, _hoisted_11)
    ])
  ]))
}